import { Routes } from '@angular/router';
import { EcommerceComponent } from './pages/dashboard/ecommerce/ecommerce.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/auth-pages/sign-up/sign-up.component';
import { AuthGuard } from './security/auth.guard';
import { GuestGuard } from './security/guest.guard';
import { ClientsComponent } from './pages/clients/clients.component';
import { ProductComponent } from './pages/product/product.component';
import { ServiceComponent } from './pages/services/service.component';
import { SaleComponent } from './pages/sales/sale.component';
import { CreditDebitNoteComponent } from './pages/credit-debit-notes/credit-debit-note.component';
import { RemissionGuideComponent } from './pages/remission-guides/remission-guide.component';
import { SunatDocumentsComponent } from './pages/sunat-documents/sunat-documents.component';
import { SalesReportComponent } from './pages/reports/sales-report/sales-report.component';
import { RemissionGuidesReportComponent } from './pages/reports/remission-guides-report/remission-guides-report.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { CarrierComponent } from './pages/carriers/carrier.component';
import { OriginPointComponent } from './pages/origin-points/origin-point.component';
import { DriverComponent } from './pages/drivers/driver.component';
import { MenusComponent } from './pages/security/menus/menus.component';
import { ProfilesComponent } from './pages/security/profiles/profiles.component';
import { SecurityUsersComponent } from './pages/security/users/security-users.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: EcommerceComponent,
        pathMatch: 'full',
        title:
          'Inicio | IDMH Perú',
      },
      {
        path: 'clients',
        component: ClientsComponent,
        title: 'Clientes | IDMH Perú'
      },
      {
        path: 'products',
        component: ProductComponent,
        title: 'Productos | IDMH Perú'
      },
      {
        path: 'services',
        component: ServiceComponent,
        title: 'Servicios | IDMH Perú'
      },
      {
        path: 'sales',
        component: SaleComponent,
        title: 'Ventas | IDMH Perú'
      },
      {
        path: 'credit-debit-notes',
        component: CreditDebitNoteComponent,
        title: 'Notas de Crédito / Débito | IDMH Perú'
      },
      {
        path: 'remission-guides',
        component: RemissionGuideComponent,
        title: 'Guías de Remisión | IDMH Perú'
      },
      {
        path: 'sunat-documents',
        component: SunatDocumentsComponent,
        title: 'Adm. Comprobantes | IDMH Perú'
      },
      {
        path: 'reports/sales',
        component: SalesReportComponent,
        title: 'Reporte de Ventas | IDMH Perú'
      },
      {
        path: 'reports/remission-guides',
        component: RemissionGuidesReportComponent,
        title: 'Reporte de Guías | IDMH Perú'
      },
      {
        path: 'configuration',
        component: ConfigurationComponent,
        title: 'Configuración | IDMH Perú'
      },
      {
        path: 'carriers',
        component: CarrierComponent,
        title: 'Transportistas | IDMH Perú'
      },
      {
        path: 'origin-points',
        component: OriginPointComponent,
        title: 'Puntos de Partida | IDMH Perú'
      },
      {
        path: 'drivers',
        component: DriverComponent,
        title: 'Conductores | IDMH Perú'
      },
      {
        path: 'security/menus',
        component: MenusComponent,
        title: 'Menús | IDMH Perú'
      },
      {
        path: 'security/profiles',
        component: ProfilesComponent,
        title: 'Perfiles | IDMH Perú'
      },
      {
        path: 'security/users',
        component: SecurityUsersComponent,
        title: 'Usuarios | IDMH Perú'
      },
      {
        path: 'my-profile',
        component: MyProfileComponent,
        title: 'Mi Perfil | IDMH Perú'
      },
    ]
  },
  // auth pages
  {
    path: 'signin',
    component: SignInComponent,
    canActivate: [GuestGuard],
    title: 'Iniciar Sesión | IDMH Perú'
  },
  {
    path: 'signup',
    component: SignUpComponent,
    canActivate: [GuestGuard],
    title: 'Registro | IDMH Perú'
  },
  // error pages
  {
    path: '**',
    component: NotFoundComponent,
    canActivate: [GuestGuard],
    title: 'Not Found | IDMH Perú'
  },
];
